import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoadingScreen } from "Components";
import { newAuthService } from "Service/Axios";
import { getCareerHubJobsListUrl } from "Constant/api";
import { paths } from "Constant/paths";

export const TrendingJobs = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [jobsList, setJobsList] = useState([]);

  const fetchJobsList = async () => {
    // setJobsLoading(true);
    const payload = {
      skip: 0,
      take: 3,
    };
    const response = await newAuthService(
      getCareerHubJobsListUrl,
      "POST",
      payload
    );
    setJobsList(response.data.data);
    setLoading(false);
  };

  useEffect(() => {
    fetchJobsList();
  }, []);

  const onRedirectToApply = (formId, urlParameter, website, email) => {
    if (formId) {
      const formUrl = `${paths.formBuilder.applicationForm}/${formId}`;
      navigate(urlParameter ? `${formUrl}?${urlParameter}` : formUrl);
    } else if (website) {
      window.open(website, "_blank");
    } else if (email) {
      window.location.href = `mailto:${email}`;
    } else {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  if (loading) return <LoadingScreen />;

  if (!Array.isArray(jobsList) || jobsList.length === 0) return null;

  return (
    <div className="p-4 rounded-lg border border-grey-200 bg-white d-flex flex-column gap-0">
      <h4 className="text-md font-semibold text-grey-800">
        {t("auth.viewProfile.trendingJobs")}
      </h4>
      <ul className="people-help-list list-unstyled mb-0 flex flex-column">
        {jobsList.map((job, idx) => (
          <li className="py-3" key={idx.toString()}>
            <div className="d-flex flex-wrap justify-content-between align-items-center column-gap-3 row-gap-2 mb-3">
              <div className="d-flex align-items-center gap-2">
                <div className="flex-none w-12 h-12 rounded-circle border border-gray-200 d-flex justify-content-center align-items-center overflow-hidden">
                  <img
                    src={
                      job.image ? job.image : "/assets/images/placeholder.jpg"
                    }
                    alt=""
                    className="w-100 h-100 object-fit-cover"
                  />
                </div>
                <div>
                  <h5 className="mb-0 text-sm font-medium line-clamp-1">{job.name}</h5>
                  <span className="text-xs">{job.type}</span>
                </div>
              </div>

              <button
                className="btn btn-gray-light d-inline-flex align-items-center gap-1"
                onClick={() =>
                  onRedirectToApply(
                    job.formId,
                    job.urlParameter,
                    job.website,
                    job.email
                  )
                }
              >
                <i className="bx bx-plus bx-xs"></i> {t("common.button.apply")}
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
